import { ref, onMounted, onUnmounted } from 'vue';

export function useNavbar() {
  const isMenuActive = ref(false);
  const isHeaderActive = ref(false);
  const isGoTopActive = ref(false);

  const toggleMenu = () => {
    isMenuActive.value = !isMenuActive.value;
  };

  const handleScroll = () => {
    isHeaderActive.value = window.scrollY >= 400;
    isGoTopActive.value = window.scrollY >= 400;
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  return {
    isMenuActive,
    isHeaderActive,
    isGoTopActive,
    toggleMenu,
    handleScroll,
  };

  
}


